import React from 'react'
import { Link } from 'react-scroll'

export const PcGlobalMenus = () => {

  return (
    <nav className="pc-global-menus">
      <ul>
        <li><Link to="page-system" smooth={true} duration={300}>システムの特徴</Link></li>
        <li><Link to='page-aligner' smooth={true} duration={300}>アライナーの特徴</Link></li>
        <li><Link to='page-value' smooth={true} duration={300}>提供価値</Link></li>
        <li><Link to='page-example' smooth={true} duration={300}>導入事例</Link></li>
        <li><Link to='page-owner' smooth={true} duration={300}>創業者の想い</Link></li>
      </ul>
    </nav>
  )
}